<template>
    <div :class="menuClass">
        <i class="fa-solid fa-bars nav__burger" @click="burgerClick"></i>
        <div class="nav__nav">
            <div class="nav__logo">
                <img src="assets/logo.png" alt="logo van Devenox">
            </div>
            <div class="nav__buttons">
                <router-link to="/" class="nav__buttons__btn" @click="burgerClick"><i class="fa-solid fa-chart-pie"></i>Dashboard</router-link>
                <router-link to="/pages" class="nav__buttons__btn" @click="burgerClick"><i class="fa-solid fa-file"></i>Pagina's</router-link>
                <router-link to="/files" class="nav__buttons__btn" @click="burgerClick"><i class="fa-solid fa-folder-open"></i>Bestanden</router-link>
                <router-link to="/media" class="nav__buttons__btn" @click="burgerClick"><i class="fa-solid fa-image"></i>Media</router-link>
                <!-- <router-link to="/stats" class="nav__buttons__btn nav__comingsoon" @click="burgerClick"><i class="fa-solid fa-chart-simple"></i>Statistieken</router-link>
                <router-link to="/contacts" class="nav__buttons__btn nav__comingsoon" @click="burgerClick"><i class="fa-solid fa-address-book"></i>Formulieren</router-link> -->
            </div>
        </div>
        <div class="nav__account">
            <!-- <p class="t_mini">Ingelogd als {{ this.status.userName }}</p>
            <br> -->
            <p class="button" @click="logout"><i class="fa-solid fa-right-from-bracket"></i> Uitloggen</p>
            <p class="nav__version">&copy; {{copy}}</p>
            <p class="nav__version">{{version}}</p>
        </div>
    </div>
</template>
<script>
export default {
    inject:['status'],
    data(){
        return{
            burgerMenu: false,
            menuClass: "nav",
            copy: "",
            version: ""
        }
    },
    created(){
        let date = new Date();
        this.copy = "Devenox - " + date.getFullYear();
        this.version = "V" + this.status.version;

    },  
    methods:{
        burgerClick(){
            if(this.burgerMenu){
                this.burgerMenu = false;
                this.menuClass = "nav"
            } else{
                this.burgerMenu = true;
                this.menuClass = "nav nav__active"
            }
        },
        logout(){
            if(localStorage.DevUser){
                localStorage.removeItem("DevUser");
                localStorage.removeItem("DevUserName");
                localStorage.removeItem("DevUserMail");
                localStorage.removeItem("DevUserPass");
                localStorage.removeItem("DevDatabase");
                localStorage.removeItem("DevUserCompany");
            } else if (sessionStorage.DevUser){
                sessionStorage.removeItem("DevUser");
                sessionStorage.removeItem("DevUserName");
                sessionStorage.removeItem("DevUserMail");
                sessionStorage.removeItem("DevUserPass");
                sessionStorage.removeItem("DevDatabase");
                sessionStorage.removeItem("DevUserCompany");
            }
            this.status.user = false;
            this.status.userName = "";
            this.status.userMail = "";
            this.status.userPass = "";
            this.status.userCompany = "";
            this.status.db = "test_db";
            this.status.customerStats = false;
            this.$router.push('/login');
        }
    }
}
</script>
<style>
    a.router-link-active{
        background-color: rgba(38, 125, 225, 0.1);
        transition: .5s;
    }
</style>